/*******************************************************************************
* @ngdoc       provider
* @name        BankReconServiceProvider
* @module      csm.books.BankRecon
* @description 
* Provides configuration of the BankReconService.
*******************************************************************************/
/* @ngInject */ export function BankReconServiceProvider() {
  this.httpServiceBase = '/books/bankRecon/';
  this.httpServices = {
    dropStatement: function (id) {
      return this.get('dropStatement/{0}'.format(id));
    },
    saveStatement: function (data) {
      return this.post('saveStatement', data);
    },
    getStatement: function (id) {
      return this.get('getStatement/{0}'.format(id));
    },
    getStatementItems: function (accountID, statementDate, statementID) {
      return this.post('getStatementItems', {
        accountID: accountID,
        statementDate: statementDate,
        statementID: statementID
      });
    },
    getStatementList: function (accountID, reconciled) {
      return this.post('getStatementList', {
        accountID: accountID,
        reconciled: reconciled
      });
    }
  };

  /**
   * @ngdoc       service
   * @name        ReceiptsService
   * @module      csm.books.WriteReceipts
   * @description Receipts controller services.
   */
  this.$get = ['HTTPService', function (HTTPService) {
    return Object.assign(
      HTTPService.make(this.httpServiceBase),
      this.httpServices
    );
  }];
}
